module.exports = __webpack_public_path__ + "img/18.8.1bc25355.png";